export const state = () => ({
  title: '',
  description: '',
  ogUrl: '',
  ogImage: '',
  ogType: 'website',
  canonical: '',
  mobileUrl: '',
  h1: '',
  jsonLd: []
})

export const mutations = {
  set (state, meta) {
    state.title = meta.title || ''
    state.description = meta.description || ''
    state.ogUrl = meta.ogUrl || ''
    state.ogImage = meta.ogImage || ''
    state.ogType = meta.ogType || 'website'
    state.canonical = meta.canonical || ''
    state.mobileUrl = meta.mobileUrl || ''
    state.h1 = meta.h1 || ''
    state.jsonLd = meta.jsonLd || []
  },
  clear (state) {
    state.title = ''
    state.description = ''
    state.ogUrl = ''
    state.ogImage = ''
    state.ogType = 'website'
    state.canonical = ''
    state.mobileUrl = ''
    state.h1 = ''
    state.jsonLd = []
  }
}

export const getters = {
  getMeta: state => state
}
